/* unplugin-vue-components disabled */import { render } from "./DownloadBottom.vue?vue&type=template&id=1e82e4c7"
import script from "./DownloadBottom.vue?vue&type=script&lang=js"
export * from "./DownloadBottom.vue?vue&type=script&lang=js"

import "./DownloadBottom.vue?vue&type=style&index=0&id=1e82e4c7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__